import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AlertModal } from './components/shared/Alert/Alert';

// Run Local - Only set fake tokens in development mode
// let currentTime = new Date().getTime();
// currentTime = currentTime + (3600 * 1000);
// const fakeToken = {
//   id_token: "id_token",
//   access_token: "access_token",
//   expires_in: currentTime,
//   username : "TestUser@genpt.com"
// };

// let store = {
//   TokenInfo: JSON.stringify(fakeToken),
// };
// sessionStorage.setItem("TokenInfo", store.TokenInfo)
// RUN LOCAL End

    ReactDOM.render(
                <>
                   <AlertModal/>
                    <App/>
                </>
            ,
        document.getElementById('root')
    )